import api from '..';

export default function ({ office } = {}) {
  return api
    .post('/tourclient/account/currentUserDepartment', `id=${office?.value}`)
    .then((data) => {
      if (data.Success) {
        return office;
      }
      return Promise.reject('Неизвестная ошибка');
    })
    .catch(() => Promise.reject('Неизвестная ошибка'));
}
